import { SITE_NAME } from "./siteMetadata.js";

const MANAGED_SELECTOR = 'title, meta[name="description"], meta[name="keywords"], meta[name="robots"], meta[property^="og:"], meta[name^="twitter:"], link[rel="canonical"], script[data-xavier-seo], #ld-json-service, #ld-json-city';

export function applyMetadata(document, metadata) {
  // A single owner prevents stale descriptions/canonicals after Back/Home navigation.
  document.head.querySelectorAll(MANAGED_SELECTOR).forEach((node) => node.remove());
  document.title = metadata.title;
  function meta(key, content, attribute = 'name') {
    const element = document.createElement('meta');
    element.setAttribute(attribute, key);
    element.setAttribute('content', content);
    document.head.appendChild(element);
  }
  meta('robots', metadata.robots);
  if (!metadata.page) return;
  meta('description', metadata.description);
  const canonical = document.createElement('link');
  canonical.rel = 'canonical';
  canonical.href = metadata.canonical;
  document.head.appendChild(canonical);
  const graph = {
    'og:type': 'website', 'og:site_name': SITE_NAME, 'og:title': metadata.title,
    'og:description': metadata.description, 'og:url': metadata.canonical,
    'og:image': metadata.image, 'og:image:alt': 'Xavier Assembly logo', 'og:locale': 'en_US',
  };
  Object.entries(graph).forEach(([key, value]) => meta(key, value, 'property'));
  meta('twitter:card', 'summary');
  meta('twitter:title', metadata.title);
  meta('twitter:description', metadata.description);
  meta('twitter:image', metadata.image);
  meta('twitter:image:alt', 'Xavier Assembly logo');
  if (metadata.schema) {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-xavier-seo', '');
    script.textContent = JSON.stringify(metadata.schema);
    document.head.appendChild(script);
  }
}

